import { RegisteredNpi } from '@/types/npi.ts';
import { PatientOacEnum } from '@/types/patient.ts';

export const OAC_OPTIONS = Object.values(PatientOacEnum).map((option) => ({
  label: option,
  value: option
}));

export const getReferringProviderName = ({
  referringProvider,
  isEHRIntegrated,
  referringPhysician
}: {
  referringProvider?: RegisteredNpi | null;
  isEHRIntegrated?: boolean;
  referringPhysician?: string | null;
}): string => {
  if (referringProvider) {
    const { firstName = '', lastName = '', NPI = '' } = referringProvider;
    const npiDetails = !isEHRIntegrated ? `(${NPI})` : '';
    return `${firstName} ${lastName} ${npiDetails}`.trim();
  }
  return referringPhysician ?? '';
};
